"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
Object.defineProperty(Intl, 'DisplayNames', {
    value: _1.DisplayNames,
    enumerable: false,
    writable: true,
    configurable: true,
});
